<div
  class="participant-tile"
  [class.speaking]="participant?.isSpeaking"
  [class.video-off]="!participant?.isCameraEnabled"
>
  <!-- Video element -->
  <video
    #videoElement
    autoplay
    playsinline
    [muted]="isLocal"
    class="participant-video"
    *ngIf="participant?.isCameraEnabled"
  ></video>

  <!-- Audio element for remote participants -->
  <audio #audioElement autoplay *ngIf="!isLocal" style="display: none"></audio>

  <!-- Avatar when video is off -->
  <div class="participant-avatar" *ngIf="!participant?.isCameraEnabled">
    <span class="avatar-initials">{{ getInitials() }}</span>
  </div>

  <!-- Participant info overlay -->
  <div class="participant-info">
    <div class="participant-meta">
      <span class="participant-name">
        {{ participant?.name | doctorName: participant?.professionalTitle }}
        <span *ngIf="isLocal">({{ "group-call.you" | translate }})</span>
      </span>
      <span class="participant-branch" *ngIf="participant?.branchName as branch">
        {{ "profile.branch" | translate }}: {{ branch }}
      </span>
    </div>
    <div class="status-icons">
      <img
        src="/assets/icons/mic-off.svg"
        class="status-icon"
        *ngIf="!participant?.isMicEnabled"
      />
      <img
        src="/assets/icons/camera-off.svg"
        class="status-icon"
        *ngIf="!participant?.isCameraEnabled"
      />
    </div>
  </div>

  <!-- Speaking indicator -->
  <div class="speaking-indicator" *ngIf="participant?.isSpeaking">
    <span class="pulse"></span>
  </div>
</div>
